import axios from 'axios'
import moment from 'moment'
import Deneric from 'deneric2'
import {ENV} from "@/apps/rever-academy/components/Constant";
import {data} from "jquery";


const BASE_ENDPOINT = process.env.contact_from_api
const DEFAULT_DESCRIPTION = ENV.VUE_APP_FORM_DESCRIPTION_NOTE || ''

class RegisterFormService {
  id: string | undefined
  constructor() {
    this.id = process.env.id_submit_form
  }
  submit(formData:any) {
    const url = `${BASE_ENDPOINT}/${this.id}`
    console.log("hhhhihi",formData)
    return axios.post(url,  formData)
  }
}

const instance: RegisterFormService = new RegisterFormService()

export class Item {
  param!: string
  value!: string
  constructor (param: string,val:string) {
    this.param = param
    this.value = val
  }
}


//
// export class RegisterRequest extends Deneric{
//   firstname: string = ''
//   lastname: string = ''
//   email: string = ''
//   phone: string = ''
//   class: any = []
//   department: string = ''
//   constructor(rawData?: object) {
//     super({
//       firstname: ['firstname', String],
//       lastname: ['lastname', String],
//       email: ['email', String],
//       phone: ['phone', String],
//       class: ['class', String],
//       department: ['department', String]
//     })
//     this.fromJson(rawData)
//
//   }
//
//   getContext() {
//     return {
//       page_url: location.href,
//       page_name: document.title,
//       hutk: this.getCookies('hubspotutk')
//     }
//   }
//   getCookies(key = '') {
//     let res = (document.cookie || '')
//       .split(';')
//       .map(c => (c || '').trim().split('='))
//       .filter(x => `${Array.isArray(x) ? x[0] : ''}`.toLowerCase() === `${key}`.toLowerCase())
//     if (Array.isArray(res) && Array.isArray(res[0])) {
//       return res[0][1]
//     }
//     return null
//   }
//
//   get serializeData() {
//     const ser :any = {
//       data : []
//     }
//     const dataAssigned:any = { ...this }
//     console.log("hehehe",dataAssigned)
//     // dataAssigned.courseStartDate = moment(dataAssigned.courseStartDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
//     ser.data = Object.keys(dataAssigned).reduce((data: any[], key) => {
//       console.log("hahahah",dataAssigned[key])
//       if (Array.isArray(dataAssigned[key])) {
//         dataAssigned[key].forEach(item => {
//           data.push({
//             param: key,
//             value: item
//           })
//         })
//       } else {
//         data.push({
//           param: key,
//           value: dataAssigned[key]
//         })
//       }
//       return data
//     }, [])
//     ser.context = this.getContext()
//     return ser
//   }
// }

export class RegisterRequest {
    firstname: string = ''
  lastname: string = ''
  email: string = ''
  phone: string = ''
  class: any = []
  address: string = ''
  constructor(data:any = {}) {
    this.firstname = data.firstname || ''
    this.lastname = data.lastname || ''
    this.email = data.email || ''
    this.phone = data.phone || ''
    this.class = data.class || []
    this.address = data.address || ''
    // this.description_note = data.description_note || DEFAULT_DESCRIPTION
  }


  // getContext() {
  //   return {
  //     page_url: 121212,
  //     page_name:121212,
  //     hutk: 121212
  //   }
  // }


  // get serializeData() {
  //   const ser: any = {
  //     data: []
  //   }
  //   const dataAssigned = { ...this }
  //   // dataAssigned.course_start_date = moment(dataAssigned.course_start_date, 'DD/MM/YYYY').format('YYYY-MM-DD')
  //   ser.data = Object.keys(dataAssigned).reduce((data:any, key) => {
  //     if (Array.isArray(dataAssigned[key])) {
  //       dataAssigned[key].forEach(item => {
  //         data.push({
  //           param: key,
  //           value: item
  //         })
  //       })
  //     } else {
  //       data.push({
  //         param: key,
  //         value: dataAssigned[key]
  //       })
  //     }
  //     return data
  //   }, [])
  //   ser.context = this.getContext
  //
  //   return ser
  // }
}

export default instance
